import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20elegant%20workspace%20with%20sleek%20laptop%20displaying%20colorful%20organized%20data%20dashboard%2C%20cream%20desk%20surface%2C%20green%20plant%2C%20coffee%20cup%2C%20warm%20afternoon%20sunlight%20through%20window%2C%20minimalist%20Scandinavian%20office%20aesthetic%2C%20soft%20beige%20and%20ivory%20palette%2C%20high%20resolution%20editorial%20photography&width=1800&height=900&seq=hero-hipobuy-v2-2026&orientation=landscape"
        alt="Hipobuy Spreadsheet workspace moderne"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto mb-6 drop-shadow-lg">
          Hipobuy Spreadsheet — Le système le plus complet pour organiser et analyser vos données
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 font-light leading-relaxed drop-shadow-md">
          Découvrez le guide ultime du <strong className="font-semibold text-white">hipobuy spreadsheet</strong>, avec comparaisons, tutoriels et outils avancés pour maximiser votre efficacité.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap hover:bg-accent-400 transition-all cursor-pointer shadow-lg shadow-accent-500/25"
          >
            Explorer le Hipobuy Spreadsheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/70 text-white font-semibold text-sm md:text-base whitespace-nowrap hover:bg-white hover:text-foreground-900 transition-all cursor-pointer"
          >
            Buy It Now
          </a>
          <Link
            to="/article/guide-complet-hipobuy-spreadsheet"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-white/30 text-white font-medium text-sm md:text-base whitespace-nowrap hover:bg-background-50/25 transition-all cursor-pointer"
          >
            Lire le Guide Complet
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white drop-shadow">+10</p>
            <p className="text-xs text-white/65 mt-1">Articles SEO</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white drop-shadow">2026</p>
            <p className="text-xs text-white/65 mt-1">Mis à jour</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white drop-shadow">14</p>
            <p className="text-xs text-white/65 mt-1">Catégories</p>
          </div>
        </div>
      </div>
    </section>
  );
}